module.exports = __webpack_public_path__ + "img/LBY.e1486b40.svg";